import { render } from "./corner-right-down.vue?vue&type=template&id=6ea76b32"
const script = {}
script.render = render

export default script